import { AutocompleteWithLabel } from '@adotel/components'
import React, { memo, useEffect, useState } from 'react'

import { getTranslate } from '../../localization'
import {
  Accommodation,
  AccommodationDataWithRatePlans
} from '../../types/accommodation'
import useStyles from './styles/EntitySelection.styles'

interface EntitySelectionFiltersProps {
  accs: AccommodationDataWithRatePlans[]
  setaccs: (v: AccommodationDataWithRatePlans[]) => void
  data: Accommodation[] | undefined
  loadingAccs: boolean
  setinputVal: (val: string) => void
  isRoleAccommodation: boolean
}

const EntitySelectionFilters: React.FC<EntitySelectionFiltersProps> = ({
  accs,
  setaccs,
  data,
  loadingAccs,
  setinputVal,
  isRoleAccommodation
}) => {
  const classes = useStyles()
  const [valueForModifyContract, setValueForModifyContract] = useState<
    {
      label: string
      value: string
      code: string
    }[]
  >([])

  useEffect(() => {
    const temp = accs.map((a) => {
      return {
        label: a.label,
        value: a.value,
        code: a.code
      }
    })

    setValueForModifyContract(temp)
  }, [accs])

  const options = data
    ? data.map((value: Accommodation) => ({
        label: value.basicDetails.name,
        value: value.basicDetails.propertyCode,
        id: value.basicDetails.accommodationID,
        tenantCode: value.basicDetails.tenantCode,
        code: value.basicDetails.displayPropertyCode,
        tenantID: value.basicDetails.tenantId || '',
        defaultProviderCode: value.basicDetails.defaultProviderCode
      }))
    : []

  return (
    <div className={classes.filtersContainer}>
      {!isRoleAccommodation && (
        <div className={classes.accFieldFilter}>
          <AutocompleteWithLabel
            loading={loadingAccs}
            loadingText={getTranslate('Loading') + '...'}
            label={getTranslate('Accommodations')}
            placeholder={getTranslate(
              'Select Accommodations to view their rate plans'
            )}
            size="small"
            value={valueForModifyContract}
            getOptionLabel={(option) => option.label || ''}
            getOptionSelected={(option, value) => option.code === value.code}
            options={options}
            onChange={(e, v: any) => {
              const selectedAccs: AccommodationDataWithRatePlans[] = []
              v.map((value: AccommodationDataWithRatePlans) =>
                selectedAccs.push({
                  label: value.label,
                  value: value.value,
                  id: value.id,
                  propertyCode: value.value,
                  code: value.value,
                  ratePlans:
                    accs.find((item) => item.id === value.id)?.ratePlans || [],
                  tenantCode: value.tenantCode,
                  tenantID: value.tenantID,
                  defaultProviderCode: value.defaultProviderCode
                })
              )
              setaccs([...selectedAccs])
              // Clear the search on EVERY selection change, not just when the
              // last accommodation is removed: a query written for the old
              // selection silently filters the (re)loaded rate plans of the
              // surviving selection — same rationale as Bulk's clear.
              setinputVal('')
            }}
            inputSize="small"
            multiple
          />
        </div>
      )}
    </div>
  )
}

export default memo(EntitySelectionFilters)
